<template>
  <div
    :class="s.route"
    class="fs-xs"
    v-if="locations">
    <div :class="[s.location, s.pickup]">
      <div class="d-flex justify-content-start align-items-center">
        <i class="fa-solid fa-location-dot"/>
        <div>
          <div>{{ locations.p_address }}</div>
          <div v-if="locations.p_title" class="mt-2">{{ locations.p_title }}</div>
          <ApproximateWarning v-if="locations.p_is_approximate === 1"/>
        </div>
      </div>
      <a
        v-if="showLink2Map"
        :href="`https://www.google.com/maps/dir/?api=1&destination=${locations.p_lat},${locations.p_lng}`"
        target="_blank">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm">ルート</button>
      </a>
    </div>
    <div :class="s.route_bar"/>
    <div :class="[s.location, s.destination]">
      <div class="d-flex justify-content-between align-items-center">
        <i class="fa-solid fa-location-dot"/>
        <div>
          <div>{{ locations.d_address }}</div>
          <div v-if="locations.d_title" class="mt-2">{{ locations.d_title }}</div>
          <ApproximateWarning v-if="locations.d_is_approximate === 1"/>
        </div>
      </div>
      <a
        v-if="showLink2Map"
        :href="`https://www.google.com/maps/dir/?api=1&destination=${locations.d_lat},${locations.d_lng}`"
        target="_blank">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm">ルート</button>
      </a>
    </div>
  </div>
</template>

<script>
import ApproximateWarning from './ApproximateWarning.vue';

export default {
  name: 'route',
  components: {
    ApproximateWarning,
  },
  props: {
    locations: {
      type: Object,
    },
    showLink2Map: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module="s">
.route {
  .location {
    width: 100%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    i {
      margin-right: 8px;
      font-size: 20px;
    }
    &.pickup {
      background-color: var(--bg-green);
      i {
        color: var(--primary-green);
      }
    }
    &.destination {
      background-color: var(--bg-pink);
      i {
        color: var(--primary-pink);
      }
    }
  }
}
.route_bar{
  &:nth-child(2) {
    height: 12px;
    width: 5px;
    margin-left: 12px;
    background-color: var(--label-secondary);
  }
}

</style>
